export function Spinner({ size = 'md', className = '' }: { size?: 'sm' | 'md' | 'lg'; className?: string }) {
  const s = size === 'sm' ? 'w-4 h-4' : size === 'lg' ? 'w-10 h-10' : 'w-8 h-8';
  return <div class={`${s} border-2 border-slate-700 border-t-cyan-400 rounded-full animate-spin ${className}`.trim()}></div>;
}

export function PageSpinner({ label = 'Loading…' }: { label?: string }) {
  return (
    <div class="flex flex-col items-center justify-center py-12">
      <Spinner />
      <p class="text-slate-400 mt-4 text-sm">{label}</p>
    </div>
  );
}

export function ButtonSpinner() {
  return (
    <svg class="w-4 h-4 animate-spin inline" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
    </svg>
  );
}
